import React, { memo } from "react";
import './Player.css';
import { getSkin } from '../Shop/ShopConfig'; // Import helper

const PLAYER_SIZE_RATIO = 0.75;
const PLAYER_OFFSET_RATIO = 0.125;

function Player({ gridX, gridY, tileSize, gapSize, deathType, isGhost, skinId = 'default' }) {
    
    // Calculate pixel position
    const pixelX = gridX * (tileSize + gapSize) + tileSize * PLAYER_OFFSET_RATIO;
    const pixelY = gridY * (tileSize + gapSize) + tileSize * PLAYER_OFFSET_RATIO;

    const style = {
        '--x': `${pixelX}px`,
        '--y': `${pixelY}px`,
        width: `${tileSize * PLAYER_SIZE_RATIO}px`,
        height: `${tileSize * PLAYER_SIZE_RATIO}px`,
    };

    // Get skin config
    const skinConfig = getSkin(skinId);
    const skinClass = skinConfig ? skinConfig.cssClass : '';

    const ghostClass = isGhost ? 'ghost-active' : '';
    const deathClass = deathType === 'lava' ? 'burning' : (deathType === 'timeout' ? 'timeout-death' : '');
    
    // Append skinClass to the base class string
    const baseClass = `player ${deathClass} ${ghostClass} ${skinClass}`;

    return (
        <>
            <div className={`${baseClass} ghost ghost-2`} style={style} />
            <div className={`${baseClass} ghost ghost-1`} style={style} />
            <div className={`${baseClass} main`} style={style} />
        </>
    );
}

export default memo(Player);